import {
  hasAnySim,
  isAllNao,
  isPerguntaOutroFilled,
  isPerguntaOutroNao,
  isPerguntaOutroSim,
} from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta03ExemplosEnum,
  ConsultaSeguimentoPergunta03Model,
} from './model-consultaSeguimentoPergunta03'

const pergunta03ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta03ExemplosEnum)

export function isPergunta03ExemplosAllNao(value: ConsultaSeguimentoPergunta03Model): boolean {
  const isExemplosAllNao = isAllNao(value?.PERGUNTA_03_EXEMPLOS, pergunta03ExemplosEnumValues)

  if (isPerguntaOutroFilled(value?.OUTRO)) {
    return isExemplosAllNao && isPerguntaOutroNao(value?.OUTRO)
  }

  return isExemplosAllNao
}

export function hasPergunta03ExemplosAnySim(value: ConsultaSeguimentoPergunta03Model): boolean {
  return hasAnySim(value?.PERGUNTA_03_EXEMPLOS) || isPerguntaOutroSim(value?.OUTRO)
}

export function prunePergunta03(value: ConsultaSeguimentoPergunta03Model): ConsultaSeguimentoPergunta03Model {
  return value
}
